export default function Depoimentos() {
  const depoimentos = [
    {
      nome: 'Ricardo Mendes',
      cargo: 'Investidor desde 2023',
      avatar: 'https://i.pravatar.cc/150?img=12',
      texto: 'A transparência da Bravia me surpreendeu desde o primeiro contato. Recebi relatórios detalhados durante toda a obra.',
      headline: 'Transparência em cada etapa',
    },
    {
      nome: 'Juliana Costa',
      cargo: 'Investidora desde 2022',
      avatar: 'https://i.pravatar.cc/150?img=45',
      texto: 'Investir com a Bravia foi a melhor decisão. O retorno veio dentro do prazo e exatamente como prometido.',
      headline: 'Retorno dentro do prazo',
    },
    {
      nome: 'Fernando Silva',
      cargo: 'Investidor desde 2023',
      avatar: 'https://i.pravatar.cc/150?img=33',
      texto: 'O time da Bravia é extremamente profissional. Sempre disponíveis para tirar dúvidas e explicar cada detalhe.',
      headline: 'Atendimento excepcional',
    },
  ];

  return (
    <section className="bg-beige-50 py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <div className="w-2 h-2 bg-gold-500 rounded-full mx-auto mb-4"></div>
          <p className="text-xs font-medium tracking-widest text-gray-500 mb-6">DEPOIMENTOS</p>
          <h2 className="text-5xl mb-2">
            <span className="font-bold text-gray-400">O que dizem</span>
          </h2>
          <h2 className="text-6xl font-serif italic text-black">nossos investidores</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {depoimentos.map((depoimento, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8"
            >
              <div className="flex text-orange-400 mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-lg"></i>
                ))}
              </div>
              <h4 className="text-lg font-semibold text-black mb-3">{depoimento.headline}</h4>
              <p className="text-gray-700 leading-relaxed mb-6">{depoimento.texto}</p>
              <div className="flex items-center">
                <img
                  src={depoimento.avatar}
                  alt={depoimento.nome}
                  className="w-12 h-12 rounded-full object-cover mr-4"
                />
                <div>
                  <p className="font-bold text-black">{depoimento.nome}</p>
                  <p className="text-sm text-gray-500">{depoimento.cargo}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
